var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTracking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_12757_10697",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_12757_10697",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB5ElEQVR4nO1VPW/UQBD1QUEKdEqDENAEEhoooQYBEg0UpEkk6CkgSFciJEQLQUI0FBS0VJCCEgRX5EsEpYl8+97OrLX8E6OxfOKwz1g+6GCkkdfe2fnaN89J8l/axHt/Ssn1jHwYY5xL/rYo8EmcuyzkvQC88t6f6aoATuZ53psaIJDb9swODo4rKYF83VWVfKfAXubczWkBBgp8DuSu9/7SrJ1I0/SoAhuBvFrbFJG+iBxJ/lBijPMKbM50WMlVJd+WutJkF8idWZyvK/D0u3Mn7ELL92dVuzzPDyv5rZNzEVlU8n0RKE2XTIs1sEHydCX7x0reb3UaRqOzGXAnAHcNuurc2sRd9YsAzq3ZXmFDDgL5wapqhGtZ4qFAPjfj4hCKw08C8KJqq+RLBR6ZTQbctkpbM1fggZVZCdozZERgYfzNWqPkx1aHtdaQ+3ZRtcCj0flAfjGsmwZyKCLnZgmw27Qnzl23rE1t3dl5kSmwZcPSmABwIQAX2/wYaY7B8KsD8prBz9pQq0Ckr+Qb06mHfyZ5xTpR0s+gZpB5f0OBr4b9CqkNDQQlEIa/IT8VkWOTRFoTQ45N7SQlB++XDU2FkreaqNtmw6jfKumMtAgsTMJ1qk2Mc/bzsqEzWukUIPkn5QeyixaUd6KfEQAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracking);
export default __webpack_public_path__ + "static/media/tracking.70b964ca.svg";
export { ForwardRef as ReactComponent };